import { Box } from '@provider-portal/design-common/kalep/components/Box/Box';
import { Typography } from '@provider-portal/design-common/kalep/components/Typography/Typography';

import { MugIcon } from './icons/MugIcon';
import { useIntl } from 'react-intl';

export type StoreSelectorNoResultsStrings = Record<'noResults' | 'searchSomethingElse', string>;
export interface StoreSelectorNoResultsProps {
  query: string;
}

export function StoreSelectorNoResults({ query }: StoreSelectorNoResultsProps) {
  const intl = useIntl();
  const noResults = intl.formatMessage({ id: 'venueSelector.search.noResultsForQuery' }, { query });
  const searchSomethingElse = intl.formatMessage({
    id: 'venueSelector.search.searchSomethingElse',
  });

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      gap="24px"
    >
      <Box mt="40px">
        <MugIcon />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        gap="8px"
        px="16px"
        width="100%"
        maxWidth="100%"
      >
        <Typography
          variant="body-l-accent"
          align="center"
          sx={{
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={query}
        >
          {noResults}
        </Typography>
        <Typography variant="body-m-regular" color="secondary" align="center">
          {searchSomethingElse}
        </Typography>
      </Box>
    </Box>
  );
}
